// Client-side CSV export — mirrors generateRegisterPDF's API shape so the
// same columns/rows data can feed both a PDF and CSV button side by side.
const escapeCsvCell = (val) => {
  const s = String(val ?? '');
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const generateRegisterCSV = ({ columns, rows, filename }) => {
  const header = columns.map((c) => escapeCsvCell(c.header)).join(',');
  const body = rows.map((r) => columns.map((c) => escapeCsvCell(r[c.dataKey])).join(',')).join('\n');
  const csv = `${header}\n${body}`;

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${(filename || 'export').toLowerCase().replace(/\s+/g, '-')}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
